import { Component, OnInit, ViewChild } from '@angular/core'
import { AuthService, ModalService, RestServices, SharedServices } from '@app/services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { PaymentHelper } from '@helpers/payment.helper'
import _ from 'lodash'

@Component({
    selector: 'app-mail',
    templateUrl: './mail.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../common/common.component.css',
        './mail.component.css',
    ],
})
export class MailComponent implements OnInit {
    en = {}
    showEN = true
    alignerMail
    movieMail
    testMail
    deviceMail
    appointMail
    optionalMail
    broadcastMail = {}
    common
    formMailSetting: FormGroup
    senderName
    ccEmail
    html
    text
    title
    queryMap = {
        common: true,
        alignerMail: true,
        movieMail: true,
        option: true,
        testMail: true,
        appointMail: true,
        optionalMail: true,
        broadcastMail: true,
        deviceMail: true,
    }
    validate: any = {}
    apiMessage: 'Something went wrong!'
    rtRemoved = false

    @ViewChild('alertDialogBroadcastMailSend') alertDialogBroadcastMailSend

    constructor(private authData: AuthService, private restApi: RestServices, private router: Router, private formBuider: FormBuilder, private _sharedService: SharedServices, private modalService: ModalService) {
        this.getCommon()
    }

    ngOnInit() {
        //console.log('save mail 56=====')

        this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success === 'saveMail') {
                    console.log('save mail emit sub 59=====')
                    if (!this.rtRemoved)
                    this.saveMailSetting()
                }
            },
        )
        this.listMail()
        this.validatorForm()
        this.onSubmit()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                document.getElementById('button-end-settingmail').classList.add(themeStatus + '-setting-mail')
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    validatorForm() {
        this.formMailSetting = this.formBuider.group({
            senderName: ['', Validators.required],
            ccEmail: ['', Validators.required],
            movieMail_title: ['', Validators.required],
            movieMail_text: ['', Validators.required],
            movieMail_html: ['', Validators.required],
            alignerMail_title: ['', Validators.required],
            alignerMail_text: ['', Validators.required],
            alignerMail_html: ['', Validators.required],
            testMail_title: ['', Validators.required],
            testMail_text: ['', Validators.required],
            testMail_html: ['', Validators.required],
            deviceMail_title: ['', Validators.required],
            deviceMail_text: ['', Validators.required],
            deviceMail_html: ['', Validators.required],
            appointMail_title: ['', Validators.required],
            appointMail_text: ['', Validators.required],
            appointMail_html: ['', Validators.required],
            optionalMail_title: ['', Validators.required],
            optionalMail_text: ['', Validators.required],
            optionalMail_html: ['', Validators.required],
            broadcastMail_title: ['', Validators.required],
            broadcastMail_text: ['', Validators.required],
            broadcastMail_html: ['', Validators.required],
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    // list mail
    listMail() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: this.queryMap,
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const mailSetting = success['response']['setting']['map']
                    this.alignerMail = mailSetting['alignerMail']
                    this.movieMail = mailSetting['movieMail']
                    this.testMail = mailSetting['testMail']
                    this.deviceMail = mailSetting['deviceMail']
                    this.appointMail = mailSetting['appointMail']
                    this.optionalMail = mailSetting['optionalMail']
                    this.broadcastMail = mailSetting['broadcastMail'] || {}
                    this.common = mailSetting['common']
                    if (this.broadcastMail == '') {
                        this.validateInfo(success['user'], this.broadcastMail)
                    }
                },
            )
        })
    }

    checkEnableBroadcastMailButton() {
        const moment = require('moment-timezone')
        const user = this.authData.getUser()
        const isFree = user.is_free
        const isAvailability = user.availability === 'Off'
        const unixToDay = moment().tz('Asia/Tokyo').format('YYYY-MM-DD')
        const unixLastBroadCastDate = moment.tz(this.broadcastMail && this.broadcastMail['lastBroadCastDate'], 'Asia/Tokyo').format('YYYY-MM-DD')
        return !!!isAvailability && (!isFree || (isFree && !!user.gmoCardFlg)) && (!!!this.broadcastMail['lastBroadCastDate'] || moment(unixToDay).isAfter(unixLastBroadCastDate))
    }

    async sendBroadcastMail() {
        if (!_.size(this.broadcastMail)) {
            await this.saveMailSetting()
        }
        const valueBroadCastMail = this.getMailValue('broadcastMail')
        this.validate.alreadySent = false
        if (this.checkEnableBroadcastMailButton()) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('mails/broadcast-mail', valueBroadCastMail, tokenReNew).subscribe(
                    response => {
                        if (response && !response['status']) {
                            this.validate.alreadySent = true
                            this.apiMessage = response['message'] || 'Something went wrong!'
                        } else {
                            console.log('Sent')
                            this.listMail()
                        }
                    },
                )
            })
        } else {
            this.validate.alreadySent = true
        }
    }

    onSubmit() {
        const arrSave = this.formMailSetting.dirty ? 'activeAlertSaveMail' : null
        this._sharedService.emitChange(arrSave)
    }

    // save mail
    saveMailSetting() {
        if (this.formMailSetting.get('senderName').dirty) {
            this.senderName = this.formMailSetting.value.senderName
        }
        if (this.formMailSetting.get('ccEmail').dirty) {
            this.ccEmail = this.formMailSetting.value.ccEmail
        }
        const valueCommon = {
            senderName: this.senderName,
            ccEmail: this.ccEmail,
        }
        const valueMovieMail = this.getMailSetting('movieMail')
        const valueAlignerMail = this.getMailSetting('alignerMail')
        const valueTestMail = this.getMailSetting('testMail')
        const valueDeviceMail = this.getMailSetting('deviceMail')
        const valueAppointMail = this.getMailSetting('appointMail')
        const valueOptionalMail = this.getMailSetting('optionalMail')
        const valueBroadcastMail = this.getMailSetting('broadcastMail')
        // remove value null in Value Action
        for (const key in valueCommon) {
            if (valueCommon[key] === undefined) {
                delete valueCommon[key]
            }
        }
        const resourceData = {
            actions: [
                {
                    type: 'update',
                    id: 'common',
                    collection: 'setting',
                    value: valueCommon,
                },
                {
                    type: 'update',
                    id: 'movieMail',
                    collection: 'setting',
                    value: valueMovieMail,
                },
                {
                    type: 'update',
                    id: 'alignerMail',
                    collection: 'setting',
                    value: valueAlignerMail,
                },
                {
                    type: 'update',
                    id: 'testMail',
                    collection: 'setting',
                    value: valueTestMail,
                },
                {
                    type: 'update',
                    id: 'deviceMail',
                    collection: 'setting',
                    value: valueDeviceMail,
                },
                {
                    type: 'update',
                    id: 'appointMail',
                    collection: 'setting',
                    value: valueAppointMail,
                },
                {
                    type: 'update',
                    id: 'optionalMail',
                    collection: 'setting',
                    value: valueOptionalMail,
                },
                {
                    type: 'update',
                    id: 'broadcastMail',
                    collection: 'setting',
                    value: valueBroadcastMail,
                },
            ],
            status: {
                setting: {
                    map: this.queryMap,
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    console.log(resourceData)
                    console.log('update mail--==-===-=313')
                    this.modalService.emitChange('hiddenThenSaveMail')
                },
            )
        })
    }

    ngOnDestroy() {
        this.rtRemoved =true
        console.log("ngOnDestroy InDashBoard");
    }

    private getMailSetting(mailType) {
        const valueMail: any = {}
        if (this.formMailSetting.get(`${ mailType }_title`).dirty) {
            valueMail.title = this.formMailSetting.value[`${ mailType }_title`]
        }
        if (this.formMailSetting.get(`${ mailType }_text`).dirty) {
            valueMail.text = this.formMailSetting.value[`${ mailType }_text`]
        }
        if (this.formMailSetting.get(`${ mailType }_html`).dirty) {
            valueMail.html = this.formMailSetting.value[`${ mailType }_html`]
        }
        return valueMail
    }

    private getMailValue(mailType) {
        return {
            title: this.getElementValue(mailType + '_title'),
            text: this.getElementValue(mailType + '_text'),
            html: this.getElementValue(mailType + '_html'),
        }
    }

    getElementValue(elementId) {
        return (document.getElementById(elementId) as HTMLInputElement).value
    }

    checkSendBroadCast() {
        if (this.checkEnableBroadcastMailButton()) {
            const mailType = 'broadcastMail'
            const valueBroadCastMail = this.getMailValue(mailType)
            this.validate.checkbroadMailTitle = false
            this.validate.checkbroadMailTextHtml = false
            let result = true
            if (!valueBroadCastMail.title) {
                this.validate.checkbroadMailTitle = true
                result = false
            }

            if (!valueBroadCastMail.text && !valueBroadCastMail.html) {
                this.validate.checkbroadMailTextHtml = true
                result = false
            }

            if (!result) {
                if (!valueBroadCastMail.title) {
                    document.getElementById(mailType + '_title').focus()
                } else {
                    document.getElementById(mailType + '_text').focus()
                }
            }

            return result
        }
    }

    validateInfo(user, emailSetting) {
        if (PaymentHelper.checkNeedPaymentInfo(user, emailSetting)) {
            // check validate
            this.validate.checkbroadMailTitle = this.checkNotInfo(emailSetting.title)
            this.validate.checkbroadMailTextHtml = !emailSetting.text && !emailSetting.html
        } else {
            this.validate = {}
        }
    }

    checkNotInfo(info) {
        return !!!info
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/mail/mail.component.ts